<template>
    <a v-bind:href="item.url"
       target="_blank"
       class="event">
        <figure class="event__image-figure"
                v-bind:has-image="!!item.image"
                v-bind:style="figureStyle">
            <img v-if="item.image"
                 loading="lazy"
                 v-bind:src="item.image"
                 v-bind:alt="'Afbeelding van ' + item.name"
                 class="event__image" />
        </figure>

        <section class="event__info">
            <h3 class="event__title">{{item.name}}</h3>

            <ul class="event__details">
                <li>
                    <time v-bind:datetime="item.startDate">
                        <strong v-if="start.hasTime">{{start.timeFormatted}}</strong>
                        <span>{{start.dateFormatted}}</span>
                    </time>
                </li>

                <li v-if="item.location && item.location.name">
                    <span>{{item.location.name}}</span>
                </li>

                <li v-if="item.offers">
                    <strong v-if="item.offers.availability === 'https://schema.org/SoldOut'">Uitverkocht</strong>

                    <strong v-else-if="item.isAccessibleForFree">Gratis</strong>

                    <span v-else>€{{item.offers.price}}</span>
                </li>

                <li v-if="isNotInDutch">
                    <span>{{item.inLanguage | formatLanguage}}</span>
                </li>

                <li v-if="item.typicalAgeRange">
                    <span>Leeftijd: {{item.typicalAgeRange}}</span>
                </li>
            </ul>

            <p class="event__description">{{description}}</p>

            <p class="event__origin">
                via {{item._origin}}
            </p>
        </section>
    </a>
</template>

<script>
    import { addPeriod, datetime, formatLanguage, getLanguageCode, randomColor } from '../util.js';

    export default {
        computed : {
            description() {
                return addPeriod(this.item.description.trim());
            },

            isNotInDutch() {
                const lang = this.item.inLanguage;
                return this.item.inLanguage && getLanguageCode(lang) !== 'nl';
            },

            start() {
                return datetime(this.item.startDate);
            }
        },

        data() {
            return {
                figureStyle : {
                    backgroundColor : randomColor()
                }
            };
        },

        filters : {
            formatLanguage
        },

        props : {
            item : {
                type : Object,
                required : true
            }
        }
    }
</script>